export interface RouteConfig {
  path: string;
  titleSv: string;
  titleEn: string;
  descriptionSv: string;
  descriptionEn: string;
  category?: string;
  priority: number;
  changefreq: 'daily' | 'weekly' | 'monthly' | 'yearly';
  lastmod?: string;
  hideFromSitemap?: boolean;
}

export const routes: RouteConfig[] = [
  {
    path: '/',
    titleSv: 'Startsida',
    titleEn: 'Home',
    descriptionSv: 'Huvudsida med överblick av våra tjänster',
    descriptionEn: 'Main page with overview of our services',
    priority: 1.0,
    changefreq: 'weekly'
  },
  {
    path: '/pricing',
    titleSv: 'Priser',
    titleEn: 'Pricing',
    descriptionSv: 'Våra priser för olika tjänster',
    descriptionEn: 'Our pricing for different services',
    category: 'pricing',
    priority: 0.8,
    changefreq: 'monthly'
  },
  {
    path: '/abonnemang',
    titleSv: 'Abonnemang',
    titleEn: 'Subscriptions',
    descriptionSv: 'Månadsabonnemang för regelbundet innehåll',
    descriptionEn: 'Monthly subscriptions for regular content',
    category: 'pricing',
    priority: 0.8,
    changefreq: 'monthly'
  },
  {
    path: '/kom-igang',
    titleSv: 'Kom Igång',
    titleEn: 'Get Started',
    descriptionSv: 'Så här kommer du igång med oss',
    descriptionEn: 'How to get started with us',
    category: 'pricing',
    priority: 0.7,
    changefreq: 'monthly'
  },
  {
    path: '/reklamfilm',
    titleSv: 'Reklamfilm',
    titleEn: 'Commercial Film',
    descriptionSv: 'Professionella reklamfilmer för ditt företag',
    descriptionEn: 'Professional commercial films for your business',
    category: 'services',
    priority: 0.9,
    changefreq: 'monthly'
  },
  {
    path: '/videoavatarer',
    titleSv: 'Videoavatar',
    titleEn: 'Video Avatar',
    descriptionSv: 'AI-genererade videoavatarer',
    descriptionEn: 'AI-generated video avatars',
    category: 'services',
    priority: 0.9,
    changefreq: 'monthly'
  },
  {
    path: '/explainer-video',
    titleSv: 'Explainer Videos',
    titleEn: 'Explainer Videos',
    descriptionSv: 'Förklarande videos för dina produkter',
    descriptionEn: 'Explanatory videos for your products',
    category: 'services',
    priority: 0.9,
    changefreq: 'monthly'
  },
  {
    path: '/animerad-film',
    titleSv: 'Animerad Film',
    titleEn: 'Animated Film',
    descriptionSv: 'Anpassade animerade filmer',
    descriptionEn: 'Custom animated films',
    category: 'services',
    priority: 0.9,
    changefreq: 'monthly'
  },
  {
    path: '/testa-ditt-filmprojekt',
    titleSv: 'Testa ditt filmprojekt',
    titleEn: 'Test Your Film Project',
    descriptionSv: 'Testa ditt filmprojekt innan du satsar budgeten - AI + expertfeedback + provklipp',
    descriptionEn: 'Test your film project before investing your budget - AI + expert feedback + sample clip',
    category: 'services',
    priority: 0.9,
    changefreq: 'monthly'
  },
  {
    path: '/om-oss',
    titleSv: 'Om Oss',
    titleEn: 'About Us',
    descriptionSv: 'Läs mer om Volym Studio',
    descriptionEn: 'Learn more about Volym Studio',
    category: 'company',
    priority: 0.7,
    changefreq: 'monthly'
  },
  {
    path: '/kontakt',
    titleSv: 'Kontakt',
    titleEn: 'Contact',
    descriptionSv: 'Kontakta oss för mer information',
    descriptionEn: 'Contact us for more information',
    category: 'company',
    priority: 0.8,
    changefreq: 'monthly'
  },
  {
    path: '/kopvillkor',
    titleSv: 'Köpvillkor',
    titleEn: 'Terms & Conditions',
    descriptionSv: 'Våra allmänna villkor',
    descriptionEn: 'Our terms and conditions',
    category: 'legal',
    priority: 0.3,
    changefreq: 'yearly'
  },
  {
    path: '/cookie-policy',
    titleSv: 'Cookie Policy',
    titleEn: 'Cookie Policy',
    descriptionSv: 'Information om cookies',
    descriptionEn: 'Information about cookies',
    category: 'legal',
    priority: 0.3,
    changefreq: 'yearly'
  },
  {
    path: '/privacy-policy',
    titleSv: 'Privacy Policy',
    titleEn: 'Privacy Policy',
    descriptionSv: 'Vår integritetspolicy',
    descriptionEn: 'Our privacy policy',
    category: 'legal',
    priority: 0.3,
    changefreq: 'yearly'
  },
  // Hidden from sitemap
  {
    path: '/auth',
    titleSv: 'Inloggning',
    titleEn: 'Login',
    descriptionSv: 'Logga in på ditt konto',
    descriptionEn: 'Login to your account',
    priority: 0.2,
    changefreq: 'monthly',
    hideFromSitemap: true
  },
  {
    path: '/tack',
    titleSv: 'Tack',
    titleEn: 'Thank You',
    descriptionSv: 'Tack för ditt meddelande',
    descriptionEn: 'Thank you for your message',
    priority: 0.2,
    changefreq: 'yearly',
    hideFromSitemap: true
  },
  {
    path: '/sitemap',
    titleSv: 'Webbkarta',
    titleEn: 'Sitemap',
    descriptionSv: 'Hitta alla sidor på vår webbplats',
    descriptionEn: 'Find all pages on our website',
    priority: 0.5,
    changefreq: 'weekly',
    hideFromSitemap: true
  }
];

export const getRoutesByCategory = () => {
  const categories = {
    services: routes.filter(route => route.category === 'services'),
    pricing: routes.filter(route => route.category === 'pricing'),
    company: routes.filter(route => route.category === 'company'),
    legal: routes.filter(route => route.category === 'legal'),
    other: routes.filter(route => !route.category && !route.hideFromSitemap)
  };
  return categories;
};

export const getSitemapRoutes = () => {
  return routes.filter(route => !route.hideFromSitemap);
};